<div class="plate-number-card">
  <img src="../../../assets/icons/cafler.svg" alt="Cafler Icon" />
  <span>{{ plateValue }}</span>
</div>
